import { userAppContext } from '../../context/Context';
import { USER_ROLES_AWS_MAP } from '../../constants/userRoles';

const allProfiles = [
  {
    type: 'TRIAL',
    limitAPI: {
      minute: '10',
      day: '10',
      month: '30',
    },
    limitWeb: {
      minute: '60',
      day: '1000',
      month: '10,000',
    },
  },
  {
    type: 'ACADEMIC',
    limitAPI: {
      minute: '50',
      day: '25,000',
      month: '500,000',
    },
    limitWeb: {
      minute: '60',
      day: '1000',
      month: '10,000',
    },
  },
  {
    type: 'ACADEMIC_REVIEW',
    limitAPI: {
      minute: '50',
      day: '25,000',
      month: '500,000',
    },
    limitWeb: {
      minute: '60',
      day: '1000',
      month: '10,000',
    },
  },
  {
    type: 'STANDARD',
    limitWeb: {
      minute: '60',
      day: '1000',
      month: '10,000',
    },
  },
  {
    type: 'ADVANCED',
    limitAPI: {
      minute: '100',
      day: '50,000',
      month: '1.5M',
    },
    limitWeb: {
      minute: '60',
      day: '1000',
      month: '10,000',
    },
  },
  {
    type: 'PREMIUM',
    limitAPI: {
      minute: '100',
      day: '50,000',
      month: '1.5M',
    },
    limitWeb: {
      minute: '60',
      day: '1000',
      month: '10,000',
    },
  },
  {
    type: 'DEVELOPER',
  },
];

type QueriesLimitTableProps = {
  compact?: boolean;
};

function QueriesLimitTable({ compact = false }: QueriesLimitTableProps) {
  const { groups } = userAppContext();
  const userRole = USER_ROLES_AWS_MAP.get(groups?.[0]);

  const profileInfo = allProfiles.filter(profile => profile.type === userRole)[0];

  const profilesRestApiDifferentOutput = ['DEVELOPER', 'STANDARD'];

  return (
    <div className="table-responsive">
      {profileInfo?.type && (
        <table
          className={`table border-collapse border border-gray-300 rounded-xl overflow-hidden ${compact ? 'text-xs' : ''}`}
        >
          <thead className="bg-gray-100">
            <tr>
              <th scope="col">Type</th>
              <th scope="col">API</th>
              <th scope="col">Web</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Per minute</td>
              <td className="text-gray-400">
                {profileInfo?.type === 'STANDARD' && <p>No access to Rest API</p>}
                {profileInfo?.type === 'DEVELOPER' && <p>Infinite requests</p>}
                {!profilesRestApiDifferentOutput.includes(profileInfo.type) && profileInfo.limitAPI.minute}
              </td>
              <td className="text-gray-400">
                {profileInfo?.type === 'DEVELOPER' && <p>Infinite requests</p>}
                {profileInfo?.type !== 'DEVELOPER' && profileInfo.limitWeb.minute}
              </td>
            </tr>
            <tr>
              <td>Per day</td>
              <td className="text-gray-400">
                {profileInfo?.type === 'STANDARD' && <p>No access to Rest API</p>}
                {profileInfo?.type === 'DEVELOPER' && <p>Infinite requests</p>}
                {!profilesRestApiDifferentOutput.includes(profileInfo.type) && profileInfo.limitAPI.day}
              </td>
              <td className="text-gray-400">
                {profileInfo?.type === 'DEVELOPER' && <p>Infinite requests</p>}
                {profileInfo?.type !== 'DEVELOPER' && profileInfo.limitWeb.day}
              </td>
            </tr>
            <tr>
              <td>Per month</td>
              <td className="text-gray-400">
                {profileInfo?.type === 'STANDARD' && <p>No access to Rest API</p>}
                {profileInfo?.type === 'DEVELOPER' && <p>Infinite requests</p>}
                {!profilesRestApiDifferentOutput.includes(profileInfo.type) && profileInfo.limitAPI.month}
              </td>
              <td className="text-gray-400">
                {profileInfo?.type === 'DEVELOPER' && <p>Infinite requests</p>}
                {profileInfo?.type !== 'DEVELOPER' && profileInfo.limitWeb.month}
              </td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
}

export default QueriesLimitTable;
